import React, { useMemo, useState } from 'react';

import PropTypes from 'prop-types';

import DialogContext from './DialogContext';

const DialogProvider = ({ children }) => {
  const [activeAppointment, setActiveAppointment] = useState(null);
  const [showAppointmentDialog, setShowAppointmentDialog] = useState(false);
  const [showAppointmentFormDialog, setShowAppointmentFormDialog] = useState(false);
  const [showDeleteAppointmentDialog, setShowDeleteAppointmentDialog] = useState(false);

  const handleCloseAppointmentDialog = () => {
    setShowAppointmentDialog(false);
    setActiveAppointment(null);
  };

  const handleCloseAppointmentFormDialog = () => {
    setShowAppointmentFormDialog(false);
    setActiveAppointment(null);
  };

  const handleCloseDeleteAppointmentDialog = () => {
    setShowDeleteAppointmentDialog(false);
    setActiveAppointment(null);
  };

  const handleDeleteAppointmentClick = (appointment) => {
    setActiveAppointment(appointment);
    setShowDeleteAppointmentDialog(true);
    setShowAppointmentDialog(false);
  };

  const handleEditAppointmentClick = (appointment) => {
    setActiveAppointment(appointment);
    setShowAppointmentFormDialog(true);
    setShowAppointmentDialog(false);
  };

  const handleNewAppointmentClick = () => {
    setShowAppointmentFormDialog(true);
  };

  const handleOpenAppointmentDialog = (appointment) => {
    setActiveAppointment(appointment);
    setShowAppointmentDialog(true);
  };

  const contextValue = useMemo(
    () => ({
      activeAppointment,
      handleCloseAppointmentDialog,
      handleCloseAppointmentFormDialog,
      handleCloseDeleteAppointmentDialog,
      handleDeleteAppointmentClick,
      handleEditAppointmentClick,
      handleNewAppointmentClick,
      handleOpenAppointmentDialog,
      showAppointmentDialog,
      showAppointmentFormDialog,
      showDeleteAppointmentDialog,
    }),
    [
      activeAppointment,
      showAppointmentDialog,
      showAppointmentFormDialog,
      showDeleteAppointmentDialog,
    ]
  );

  return <DialogContext.Provider value={contextValue}>{children}</DialogContext.Provider>;
};

DialogProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default DialogProvider;
